import { useEffect, useState } from 'react';

import { findingGroupId, listFindingTickets } from 'api/alert-vault/jira';

export interface FindingTicket {
  ticket_id: string;
  external_id?: string;
  browse_link?: string;
  status: string;
  scope: string;
}

// Alert Vault tickets of a finding: the finding (parent) ticket and its
// sub-tasks. Only finding rows ("finding:<group>") have them.
export const useFindingTickets = (enabled: boolean, groupId?: string) => {
  const [tickets, setTickets] = useState<FindingTicket[]>([]);
  const group =
    enabled && String(groupId ?? '').startsWith('finding:')
      ? findingGroupId(groupId)
      : undefined;

  useEffect(() => {
    if (!group) {
      setTickets([]);
      return;
    }
    let active = true;
    listFindingTickets(group)
      .then(res => active && setTickets(res.data?.items ?? []))
      .catch(() => active && setTickets([]));
    return () => {
      active = false;
    };
  }, [group]);

  return {
    parent: tickets.find(t => t.scope === 'finding' && t.external_id),
    subtasks: tickets.filter(t => t.scope === 'subtask'),
  };
};
